var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grading-count-down"},[_c('div',{staticClass:"times"},[_vm._v(" "+_vm._s(_vm.times)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }